import React from 'react';
import CountUp from 'react-countup';
import { Skeleton } from '@mui/material';
import { isMobile } from "react-device-detect";

const UtilitySavingsCard = props => {
    const metricFontSize = isMobile ? "4vh" : "6vh";

    return(
        <div style={{height:'100%', width:'100%', padding: isMobile ? "4%" : '1% 2%', backgroundColor:'white', boxShadow:'2px 6px 12px rgb(164, 164, 164)'}}>
            <h4 style={{textAlign: 'center', marginBottom: isMobile ? "3%" : "1%"}}>{props.utility}</h4>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {
                    props.isLoading 
                    ?
                    <>
                        <Skeleton style={{ height: isMobile ? "4vh" : "5vh", width: "120px" }}/>
                    </>
                    :
                    <>
                        <span className='metric-span m-0'><CountUp separator=',' style={{color:'rgb(8,114,182)', fontSize: metricFontSize, margin: "0"}} end={props.metrics[0]} duration={1}/> {props.units}</span>
                        <span>saved {props.infoText}</span>
                    </>
                }
            </div>

            <br/>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {
                    props.isLoading 
                    ?
                    <>
                        <Skeleton style={{ height: isMobile ? "4vh" : "5vh", width: "120px" }}/>
                    </>
                    :
                    <>
                        <span className='metric-span m-0'><CountUp separator=',' style={{color:'rgb(0,177,168)', fontSize: metricFontSize, margin:'0'}} end={props.metrics[1]} duration={1}/> {'kg'}</span>
                        <span>of CO<sub>2e</sub> saved</span>
                    </>
                }
            </div>

            <br/>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {
                    props.isLoading 
                    ?
                    <>
                        <Skeleton style={{ height: isMobile ? "4vh" : "5vh", width: "120px" }}/>
                    </>
                    :
                    <>
                        <span className='metric-span m-0'><CountUp prefix='$' separator=',' style={{color:'rgb(77, 79, 83)', fontSize: metricFontSize, margin:'0'}} end={props.metrics[2]} duration={1}/></span>
                        <span>in financial savings</span>
                    </>
                }
            </div>
        </div>
    )
}

export default UtilitySavingsCard;